// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as AgenteConnectRouteImport } from './routes/agente-connect'
import { Route as AgenteDeIaParaWhatsappRouteImport } from './routes/agente-de-ia-para-whatsapp'
import { Route as AgenteIaAcademiaRouteImport } from './routes/agente-ia-academia'
import { Route as AgenteIaAdvocaciaRouteImport } from './routes/agente-ia-advocacia'
import { Route as AgenteIaBarbeariaRouteImport } from './routes/agente-ia-barbearia'
import { Route as AgenteIaClinicaRouteImport } from './routes/agente-ia-clinica'
import { Route as AgenteIaConcessionariaLojaDeVeiculosRouteImport } from './routes/agente-ia-concessionaria-loja-de-veiculos'
import { Route as AgenteIaContabilidadeRouteImport } from './routes/agente-ia-contabilidade'
import { Route as AgenteIaEcommerceRouteImport } from './routes/agente-ia-ecommerce'
import { Route as AgenteIaEscolaCursoRouteImport } from './routes/agente-ia-escola-curso'
import { Route as AgenteIaFarmaciaRouteImport } from './routes/agente-ia-farmacia'
import { Route as AgenteIaHotelRouteImport } from './routes/agente-ia-hotel'
import { Route as AgenteIaImobiliariaRouteImport } from './routes/agente-ia-imobiliaria'
import { Route as AgenteIaLoteadoraIncorporadoraRouteImport } from './routes/agente-ia-loteadora-incorporadora'
import { Route as AgenteIaOdontologiaRouteImport } from './routes/agente-ia-odontologia'
import { Route as AgenteIaOficinaMecanicaRouteImport } from './routes/agente-ia-oficina-mecanica'
import { Route as AgenteIaPetshopRouteImport } from './routes/agente-ia-petshop'
import { Route as AgenteIaPlanoDeSaudeRouteImport } from './routes/agente-ia-plano-de-saude'
import { Route as AgenteIaRestauranteRouteImport } from './routes/agente-ia-restaurante'
import { Route as AgenteIaSeguradoraRouteImport } from './routes/agente-ia-seguradora'
import { Route as AgenteIaSeguroAutoRouteImport } from './routes/agente-ia-seguro-auto'
import { Route as AgenteIaSeguroDeVidaRouteImport } from './routes/agente-ia-seguro-de-vida'
import { Route as AgenteIaSegurosRouteImport } from './routes/agente-ia-seguros'
import { Route as AgentePersonalizadoRouteImport } from './routes/agente-personalizado'
import { Route as AgenteTracaoComercialRouteImport } from './routes/agente-tracao-comercial'
import { Route as AgenteVoiceIaRouteImport } from './routes/agente-voice-ia'
import { Route as BriefingRouteImport } from './routes/briefing'
import { Route as ChatbotVsAgenteDeIaRouteImport } from './routes/chatbot-vs-agente-de-ia'
import { Route as ConsultaProcessosIaEscavadorRouteImport } from './routes/consulta-processos-ia-escavador'
import { Route as ContratoPorIaZapsignRouteImport } from './routes/contrato-por-ia-zapsign'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CrisRouteImport } from './routes/cris'
import { Route as CrmComWhatsappRouteImport } from './routes/crm-com-whatsapp'
import { Route as CrmIntegradoActivecampaignRouteImport } from './routes/crm-integrado-activecampaign'
import { Route as CrmIntegradoAdvboxRouteImport } from './routes/crm-integrado-advbox'
import { Route as CrmIntegradoAgendorRouteImport } from './routes/crm-integrado-agendor'
import { Route as CrmIntegradoAsaasRouteImport } from './routes/crm-integrado-asaas'
import { Route as CrmIntegradoAutentiqueRouteImport } from './routes/crm-integrado-autentique'
import { Route as CrmIntegradoBagyRouteImport } from './routes/crm-integrado-bagy'
import { Route as CrmIntegradoBelasisRouteImport } from './routes/crm-integrado-belasis'
import { Route as CrmIntegradoBraipRouteImport } from './routes/crm-integrado-braip'
import { Route as CrmIntegradoCaktoRouteImport } from './routes/crm-integrado-cakto'
import { Route as CrmIntegradoClicksignRouteImport } from './routes/crm-integrado-clicksign'
import { Route as CrmIntegradoClinicorpRouteImport } from './routes/crm-integrado-clinicorp'
import { Route as CrmIntegradoDigitalManagerGuruRouteImport } from './routes/crm-integrado-digital-manager-guru'
import { Route as CrmIntegradoDocusignRouteImport } from './routes/crm-integrado-docusign'
import { Route as CrmIntegradoEduzzRouteImport } from './routes/crm-integrado-eduzz'
import { Route as CrmIntegradoElementorRouteImport } from './routes/crm-integrado-elementor'
import { Route as CrmIntegradoFeegowRouteImport } from './routes/crm-integrado-feegow'
import { Route as CrmIntegradoGreennRouteImport } from './routes/crm-integrado-greenn'
import { Route as CrmIntegradoHotmartRouteImport } from './routes/crm-integrado-hotmart'
import { Route as CrmIntegradoHublaRouteImport } from './routes/crm-integrado-hubla'
import { Route as CrmIntegradoHubspotRouteImport } from './routes/crm-integrado-hubspot'
import { Route as CrmIntegradoKirvanoRouteImport } from './routes/crm-integrado-kirvano'
import { Route as CrmIntegradoKiwifyRouteImport } from './routes/crm-integrado-kiwify'
import { Route as CrmIntegradoLastlinkRouteImport } from './routes/crm-integrado-lastlink'
import { Route as CrmIntegradoLinkedinLeadGenRouteImport } from './routes/crm-integrado-linkedin-lead-gen'
import { Route as CrmIntegradoLojaIntegradaRouteImport } from './routes/crm-integrado-loja-integrada'
import { Route as CrmIntegradoMercadoPagoRouteImport } from './routes/crm-integrado-mercado-pago'
import { Route as CrmIntegradoMobiautoRouteImport } from './routes/crm-integrado-mobiauto'
import { Route as CrmIntegradoMonetizzeRouteImport } from './routes/crm-integrado-monetizze'
import { Route as CrmIntegradoOlxRouteImport } from './routes/crm-integrado-olx'
import { Route as CrmIntegradoOmieRouteImport } from './routes/crm-integrado-omie'
import { Route as CrmIntegradoPaytRouteImport } from './routes/crm-integrado-payt'
import { Route as CrmIntegradoPerfectPayRouteImport } from './routes/crm-integrado-perfect-pay'
import { Route as CrmIntegradoPipedriveRouteImport } from './routes/crm-integrado-pipedrive'
import { Route as CrmIntegradoRdStationRouteImport } from './routes/crm-integrado-rd-station'
import { Route as CrmIntegradoRespondiRouteImport } from './routes/crm-integrado-respondi'
import { Route as CrmIntegradoShopifyRouteImport } from './routes/crm-integrado-shopify'
import { Route as CrmIntegradoStripeRouteImport } from './routes/crm-integrado-stripe'
import { Route as CrmIntegradoTictoRouteImport } from './routes/crm-integrado-ticto'
import { Route as CrmIntegradoTypeformRouteImport } from './routes/crm-integrado-typeform'
import { Route as CrmIntegradoVegaCheckoutRouteImport } from './routes/crm-integrado-vega-checkout'
import { Route as CrmIntegradoWoocommerceRouteImport } from './routes/crm-integrado-woocommerce'
import { Route as CrmIntegradoYampiRouteImport } from './routes/crm-integrado-yampi'
import { Route as CrmIntegradoZapVivarealRouteImport } from './routes/crm-integrado-zap-vivareal'
import { Route as CrmParaCorretoraDeSegurosRouteImport } from './routes/crm-para-corretora-de-seguros'
import { Route as EstoqueVeiculosIaWebmotorsRouteImport } from './routes/estoque-veiculos-ia-webmotors'
import { Route as IntegracoesRouteImport } from './routes/integracoes'
import { Route as PainelSeoRouteImport } from './routes/painel-seo'
import { Route as PorQuePocESetupRouteImport } from './routes/por-que-poc-e-setup'
import { Route as PrecosRouteImport } from './routes/precos'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as AgendaIndexRouteImport } from './routes/agenda.index'
import { Route as AgendaAdminRouteImport } from './routes/agenda.admin'
import { Route as AgendaCancelarRouteImport } from './routes/agenda.cancelar'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgendaRoute = AgendaRouteImport.update({
            id: '/agenda',path: '/agenda',getParentRoute: () => rootRouteImport
          })
const AgenteConnectRoute = AgenteConnectRouteImport.update({
            id: '/agente-connect',path: '/agente-connect',getParentRoute: () => rootRouteImport
          })
const AgenteDeIaParaWhatsappRoute = AgenteDeIaParaWhatsappRouteImport.update({
            id: '/agente-de-ia-para-whatsapp',path: '/agente-de-ia-para-whatsapp',getParentRoute: () => rootRouteImport
          })
const AgenteIaAcademiaRoute = AgenteIaAcademiaRouteImport.update({
            id: '/agente-ia-academia',path: '/agente-ia-academia',getParentRoute: () => rootRouteImport
          })
const AgenteIaAdvocaciaRoute = AgenteIaAdvocaciaRouteImport.update({
            id: '/agente-ia-advocacia',path: '/agente-ia-advocacia',getParentRoute: () => rootRouteImport
          })
const AgenteIaBarbeariaRoute = AgenteIaBarbeariaRouteImport.update({
            id: '/agente-ia-barbearia',path: '/agente-ia-barbearia',getParentRoute: () => rootRouteImport
          })
const AgenteIaClinicaRoute = AgenteIaClinicaRouteImport.update({
            id: '/agente-ia-clinica',path: '/agente-ia-clinica',getParentRoute: () => rootRouteImport
          })
const AgenteIaConcessionariaLojaDeVeiculosRoute = AgenteIaConcessionariaLojaDeVeiculosRouteImport.update({
            id: '/agente-ia-concessionaria-loja-de-veiculos',path: '/agente-ia-concessionaria-loja-de-veiculos',getParentRoute: () => rootRouteImport
          })
const AgenteIaContabilidadeRoute = AgenteIaContabilidadeRouteImport.update({
            id: '/agente-ia-contabilidade',path: '/agente-ia-contabilidade',getParentRoute: () => rootRouteImport
          })
const AgenteIaEcommerceRoute = AgenteIaEcommerceRouteImport.update({
            id: '/agente-ia-ecommerce',path: '/agente-ia-ecommerce',getParentRoute: () => rootRouteImport
          })
const AgenteIaEscolaCursoRoute = AgenteIaEscolaCursoRouteImport.update({
            id: '/agente-ia-escola-curso',path: '/agente-ia-escola-curso',getParentRoute: () => rootRouteImport
          })
const AgenteIaFarmaciaRoute = AgenteIaFarmaciaRouteImport.update({
            id: '/agente-ia-farmacia',path: '/agente-ia-farmacia',getParentRoute: () => rootRouteImport
          })
const AgenteIaHotelRoute = AgenteIaHotelRouteImport.update({
            id: '/agente-ia-hotel',path: '/agente-ia-hotel',getParentRoute: () => rootRouteImport
          })
const AgenteIaImobiliariaRoute = AgenteIaImobiliariaRouteImport.update({
            id: '/agente-ia-imobiliaria',path: '/agente-ia-imobiliaria',getParentRoute: () => rootRouteImport
          })
const AgenteIaLoteadoraIncorporadoraRoute = AgenteIaLoteadoraIncorporadoraRouteImport.update({
            id: '/agente-ia-loteadora-incorporadora',path: '/agente-ia-loteadora-incorporadora',getParentRoute: () => rootRouteImport
          })
const AgenteIaOdontologiaRoute = AgenteIaOdontologiaRouteImport.update({
            id: '/agente-ia-odontologia',path: '/agente-ia-odontologia',getParentRoute: () => rootRouteImport
          })
const AgenteIaOficinaMecanicaRoute = AgenteIaOficinaMecanicaRouteImport.update({
            id: '/agente-ia-oficina-mecanica',path: '/agente-ia-oficina-mecanica',getParentRoute: () => rootRouteImport
          })
const AgenteIaPetshopRoute = AgenteIaPetshopRouteImport.update({
            id: '/agente-ia-petshop',path: '/agente-ia-petshop',getParentRoute: () => rootRouteImport
          })
const AgenteIaPlanoDeSaudeRoute = AgenteIaPlanoDeSaudeRouteImport.update({
            id: '/agente-ia-plano-de-saude',path: '/agente-ia-plano-de-saude',getParentRoute: () => rootRouteImport
          })
const AgenteIaRestauranteRoute = AgenteIaRestauranteRouteImport.update({
            id: '/agente-ia-restaurante',path: '/agente-ia-restaurante',getParentRoute: () => rootRouteImport
          })
const AgenteIaSeguradoraRoute = AgenteIaSeguradoraRouteImport.update({
            id: '/agente-ia-seguradora',path: '/agente-ia-seguradora',getParentRoute: () => rootRouteImport
          })
const AgenteIaSeguroAutoRoute = AgenteIaSeguroAutoRouteImport.update({
            id: '/agente-ia-seguro-auto',path: '/agente-ia-seguro-auto',getParentRoute: () => rootRouteImport
          })
const AgenteIaSeguroDeVidaRoute = AgenteIaSeguroDeVidaRouteImport.update({
            id: '/agente-ia-seguro-de-vida',path: '/agente-ia-seguro-de-vida',getParentRoute: () => rootRouteImport
          })
const AgenteIaSegurosRoute = AgenteIaSegurosRouteImport.update({
            id: '/agente-ia-seguros',path: '/agente-ia-seguros',getParentRoute: () => rootRouteImport
          })
const AgentePersonalizadoRoute = AgentePersonalizadoRouteImport.update({
            id: '/agente-personalizado',path: '/agente-personalizado',getParentRoute: () => rootRouteImport
          })
const AgenteTracaoComercialRoute = AgenteTracaoComercialRouteImport.update({
            id: '/agente-tracao-comercial',path: '/agente-tracao-comercial',getParentRoute: () => rootRouteImport
          })
const AgenteVoiceIaRoute = AgenteVoiceIaRouteImport.update({
            id: '/agente-voice-ia',path: '/agente-voice-ia',getParentRoute: () => rootRouteImport
          })
const BriefingRoute = BriefingRouteImport.update({
            id: '/briefing',path: '/briefing',getParentRoute: () => rootRouteImport
          })
const ChatbotVsAgenteDeIaRoute = ChatbotVsAgenteDeIaRouteImport.update({
            id: '/chatbot-vs-agente-de-ia',path: '/chatbot-vs-agente-de-ia',getParentRoute: () => rootRouteImport
          })
const ConsultaProcessosIaEscavadorRoute = ConsultaProcessosIaEscavadorRouteImport.update({
            id: '/consulta-processos-ia-escavador',path: '/consulta-processos-ia-escavador',getParentRoute: () => rootRouteImport
          })
const ContratoPorIaZapsignRoute = ContratoPorIaZapsignRouteImport.update({
            id: '/contrato-por-ia-zapsign',path: '/contrato-por-ia-zapsign',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CrisRoute = CrisRouteImport.update({
            id: '/cris',path: '/cris',getParentRoute: () => rootRouteImport
          })
const CrmComWhatsappRoute = CrmComWhatsappRouteImport.update({
            id: '/crm-com-whatsapp',path: '/crm-com-whatsapp',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoActivecampaignRoute = CrmIntegradoActivecampaignRouteImport.update({
            id: '/crm-integrado-activecampaign',path: '/crm-integrado-activecampaign',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoAdvboxRoute = CrmIntegradoAdvboxRouteImport.update({
            id: '/crm-integrado-advbox',path: '/crm-integrado-advbox',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoAgendorRoute = CrmIntegradoAgendorRouteImport.update({
            id: '/crm-integrado-agendor',path: '/crm-integrado-agendor',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoAsaasRoute = CrmIntegradoAsaasRouteImport.update({
            id: '/crm-integrado-asaas',path: '/crm-integrado-asaas',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoAutentiqueRoute = CrmIntegradoAutentiqueRouteImport.update({
            id: '/crm-integrado-autentique',path: '/crm-integrado-autentique',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoBagyRoute = CrmIntegradoBagyRouteImport.update({
            id: '/crm-integrado-bagy',path: '/crm-integrado-bagy',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoBelasisRoute = CrmIntegradoBelasisRouteImport.update({
            id: '/crm-integrado-belasis',path: '/crm-integrado-belasis',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoBraipRoute = CrmIntegradoBraipRouteImport.update({
            id: '/crm-integrado-braip',path: '/crm-integrado-braip',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoCaktoRoute = CrmIntegradoCaktoRouteImport.update({
            id: '/crm-integrado-cakto',path: '/crm-integrado-cakto',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoClicksignRoute = CrmIntegradoClicksignRouteImport.update({
            id: '/crm-integrado-clicksign',path: '/crm-integrado-clicksign',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoClinicorpRoute = CrmIntegradoClinicorpRouteImport.update({
            id: '/crm-integrado-clinicorp',path: '/crm-integrado-clinicorp',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoDigitalManagerGuruRoute = CrmIntegradoDigitalManagerGuruRouteImport.update({
            id: '/crm-integrado-digital-manager-guru',path: '/crm-integrado-digital-manager-guru',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoDocusignRoute = CrmIntegradoDocusignRouteImport.update({
            id: '/crm-integrado-docusign',path: '/crm-integrado-docusign',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoEduzzRoute = CrmIntegradoEduzzRouteImport.update({
            id: '/crm-integrado-eduzz',path: '/crm-integrado-eduzz',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoElementorRoute = CrmIntegradoElementorRouteImport.update({
            id: '/crm-integrado-elementor',path: '/crm-integrado-elementor',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoFeegowRoute = CrmIntegradoFeegowRouteImport.update({
            id: '/crm-integrado-feegow',path: '/crm-integrado-feegow',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoGreennRoute = CrmIntegradoGreennRouteImport.update({
            id: '/crm-integrado-greenn',path: '/crm-integrado-greenn',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoHotmartRoute = CrmIntegradoHotmartRouteImport.update({
            id: '/crm-integrado-hotmart',path: '/crm-integrado-hotmart',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoHublaRoute = CrmIntegradoHublaRouteImport.update({
            id: '/crm-integrado-hubla',path: '/crm-integrado-hubla',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoHubspotRoute = CrmIntegradoHubspotRouteImport.update({
            id: '/crm-integrado-hubspot',path: '/crm-integrado-hubspot',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoKirvanoRoute = CrmIntegradoKirvanoRouteImport.update({
            id: '/crm-integrado-kirvano',path: '/crm-integrado-kirvano',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoKiwifyRoute = CrmIntegradoKiwifyRouteImport.update({
            id: '/crm-integrado-kiwify',path: '/crm-integrado-kiwify',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoLastlinkRoute = CrmIntegradoLastlinkRouteImport.update({
            id: '/crm-integrado-lastlink',path: '/crm-integrado-lastlink',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoLinkedinLeadGenRoute = CrmIntegradoLinkedinLeadGenRouteImport.update({
            id: '/crm-integrado-linkedin-lead-gen',path: '/crm-integrado-linkedin-lead-gen',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoLojaIntegradaRoute = CrmIntegradoLojaIntegradaRouteImport.update({
            id: '/crm-integrado-loja-integrada',path: '/crm-integrado-loja-integrada',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoMercadoPagoRoute = CrmIntegradoMercadoPagoRouteImport.update({
            id: '/crm-integrado-mercado-pago',path: '/crm-integrado-mercado-pago',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoMobiautoRoute = CrmIntegradoMobiautoRouteImport.update({
            id: '/crm-integrado-mobiauto',path: '/crm-integrado-mobiauto',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoMonetizzeRoute = CrmIntegradoMonetizzeRouteImport.update({
            id: '/crm-integrado-monetizze',path: '/crm-integrado-monetizze',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoOlxRoute = CrmIntegradoOlxRouteImport.update({
            id: '/crm-integrado-olx',path: '/crm-integrado-olx',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoOmieRoute = CrmIntegradoOmieRouteImport.update({
            id: '/crm-integrado-omie',path: '/crm-integrado-omie',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoPaytRoute = CrmIntegradoPaytRouteImport.update({
            id: '/crm-integrado-payt',path: '/crm-integrado-payt',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoPerfectPayRoute = CrmIntegradoPerfectPayRouteImport.update({
            id: '/crm-integrado-perfect-pay',path: '/crm-integrado-perfect-pay',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoPipedriveRoute = CrmIntegradoPipedriveRouteImport.update({
            id: '/crm-integrado-pipedrive',path: '/crm-integrado-pipedrive',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoRdStationRoute = CrmIntegradoRdStationRouteImport.update({
            id: '/crm-integrado-rd-station',path: '/crm-integrado-rd-station',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoRespondiRoute = CrmIntegradoRespondiRouteImport.update({
            id: '/crm-integrado-respondi',path: '/crm-integrado-respondi',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoShopifyRoute = CrmIntegradoShopifyRouteImport.update({
            id: '/crm-integrado-shopify',path: '/crm-integrado-shopify',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoStripeRoute = CrmIntegradoStripeRouteImport.update({
            id: '/crm-integrado-stripe',path: '/crm-integrado-stripe',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoTictoRoute = CrmIntegradoTictoRouteImport.update({
            id: '/crm-integrado-ticto',path: '/crm-integrado-ticto',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoTypeformRoute = CrmIntegradoTypeformRouteImport.update({
            id: '/crm-integrado-typeform',path: '/crm-integrado-typeform',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoVegaCheckoutRoute = CrmIntegradoVegaCheckoutRouteImport.update({
            id: '/crm-integrado-vega-checkout',path: '/crm-integrado-vega-checkout',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoWoocommerceRoute = CrmIntegradoWoocommerceRouteImport.update({
            id: '/crm-integrado-woocommerce',path: '/crm-integrado-woocommerce',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoYampiRoute = CrmIntegradoYampiRouteImport.update({
            id: '/crm-integrado-yampi',path: '/crm-integrado-yampi',getParentRoute: () => rootRouteImport
          })
const CrmIntegradoZapVivarealRoute = CrmIntegradoZapVivarealRouteImport.update({
            id: '/crm-integrado-zap-vivareal',path: '/crm-integrado-zap-vivareal',getParentRoute: () => rootRouteImport
          })
const CrmParaCorretoraDeSegurosRoute = CrmParaCorretoraDeSegurosRouteImport.update({
            id: '/crm-para-corretora-de-seguros',path: '/crm-para-corretora-de-seguros',getParentRoute: () => rootRouteImport
          })
const EstoqueVeiculosIaWebmotorsRoute = EstoqueVeiculosIaWebmotorsRouteImport.update({
            id: '/estoque-veiculos-ia-webmotors',path: '/estoque-veiculos-ia-webmotors',getParentRoute: () => rootRouteImport
          })
const IntegracoesRoute = IntegracoesRouteImport.update({
            id: '/integracoes',path: '/integracoes',getParentRoute: () => rootRouteImport
          })
const PainelSeoRoute = PainelSeoRouteImport.update({
            id: '/painel-seo',path: '/painel-seo',getParentRoute: () => rootRouteImport
          })
const PorQuePocESetupRoute = PorQuePocESetupRouteImport.update({
            id: '/por-que-poc-e-setup',path: '/por-que-poc-e-setup',getParentRoute: () => rootRouteImport
          })
const PrecosRoute = PrecosRouteImport.update({
            id: '/precos',path: '/precos',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const AgendaIndexRoute = AgendaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AgendaRoute
          })
const AgendaAdminRoute = AgendaAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AgendaRoute
          })
const AgendaCancelarRoute = AgendaCancelarRouteImport.update({
            id: '/cancelar',path: '/cancelar',getParentRoute: () => AgendaRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })





const AgendaRouteChildren = {
  AgendaAdminRoute: AgendaAdminRoute,AgendaCancelarRoute: AgendaCancelarRoute,AgendaIndexRoute: AgendaIndexRoute
}

const AgendaRouteWithChildren = AgendaRoute._addFileChildren(AgendaRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgendaRoute: AgendaRouteWithChildren,AgenteConnectRoute: AgenteConnectRoute,AgenteDeIaParaWhatsappRoute: AgenteDeIaParaWhatsappRoute,AgenteIaAcademiaRoute: AgenteIaAcademiaRoute,AgenteIaAdvocaciaRoute: AgenteIaAdvocaciaRoute,AgenteIaBarbeariaRoute: AgenteIaBarbeariaRoute,AgenteIaClinicaRoute: AgenteIaClinicaRoute,AgenteIaConcessionariaLojaDeVeiculosRoute: AgenteIaConcessionariaLojaDeVeiculosRoute,AgenteIaContabilidadeRoute: AgenteIaContabilidadeRoute,AgenteIaEcommerceRoute: AgenteIaEcommerceRoute,AgenteIaEscolaCursoRoute: AgenteIaEscolaCursoRoute,AgenteIaFarmaciaRoute: AgenteIaFarmaciaRoute,AgenteIaHotelRoute: AgenteIaHotelRoute,AgenteIaImobiliariaRoute: AgenteIaImobiliariaRoute,AgenteIaLoteadoraIncorporadoraRoute: AgenteIaLoteadoraIncorporadoraRoute,AgenteIaOdontologiaRoute: AgenteIaOdontologiaRoute,AgenteIaOficinaMecanicaRoute: AgenteIaOficinaMecanicaRoute,AgenteIaPetshopRoute: AgenteIaPetshopRoute,AgenteIaPlanoDeSaudeRoute: AgenteIaPlanoDeSaudeRoute,AgenteIaRestauranteRoute: AgenteIaRestauranteRoute,AgenteIaSeguradoraRoute: AgenteIaSeguradoraRoute,AgenteIaSeguroAutoRoute: AgenteIaSeguroAutoRoute,AgenteIaSeguroDeVidaRoute: AgenteIaSeguroDeVidaRoute,AgenteIaSegurosRoute: AgenteIaSegurosRoute,AgentePersonalizadoRoute: AgentePersonalizadoRoute,AgenteTracaoComercialRoute: AgenteTracaoComercialRoute,AgenteVoiceIaRoute: AgenteVoiceIaRoute,BriefingRoute: BriefingRoute,ChatbotVsAgenteDeIaRoute: ChatbotVsAgenteDeIaRoute,ConsultaProcessosIaEscavadorRoute: ConsultaProcessosIaEscavadorRoute,ContratoPorIaZapsignRoute: ContratoPorIaZapsignRoute,CookiesRoute: CookiesRoute,CrisRoute: CrisRoute,CrmComWhatsappRoute: CrmComWhatsappRoute,CrmIntegradoActivecampaignRoute: CrmIntegradoActivecampaignRoute,CrmIntegradoAdvboxRoute: CrmIntegradoAdvboxRoute,CrmIntegradoAgendorRoute: CrmIntegradoAgendorRoute,CrmIntegradoAsaasRoute: CrmIntegradoAsaasRoute,CrmIntegradoAutentiqueRoute: CrmIntegradoAutentiqueRoute,CrmIntegradoBagyRoute: CrmIntegradoBagyRoute,CrmIntegradoBelasisRoute: CrmIntegradoBelasisRoute,CrmIntegradoBraipRoute: CrmIntegradoBraipRoute,CrmIntegradoCaktoRoute: CrmIntegradoCaktoRoute,CrmIntegradoClicksignRoute: CrmIntegradoClicksignRoute,CrmIntegradoClinicorpRoute: CrmIntegradoClinicorpRoute,CrmIntegradoDigitalManagerGuruRoute: CrmIntegradoDigitalManagerGuruRoute,CrmIntegradoDocusignRoute: CrmIntegradoDocusignRoute,CrmIntegradoEduzzRoute: CrmIntegradoEduzzRoute,CrmIntegradoElementorRoute: CrmIntegradoElementorRoute,CrmIntegradoFeegowRoute: CrmIntegradoFeegowRoute,CrmIntegradoGreennRoute: CrmIntegradoGreennRoute,CrmIntegradoHotmartRoute: CrmIntegradoHotmartRoute,CrmIntegradoHublaRoute: CrmIntegradoHublaRoute,CrmIntegradoHubspotRoute: CrmIntegradoHubspotRoute,CrmIntegradoKirvanoRoute: CrmIntegradoKirvanoRoute,CrmIntegradoKiwifyRoute: CrmIntegradoKiwifyRoute,CrmIntegradoLastlinkRoute: CrmIntegradoLastlinkRoute,CrmIntegradoLinkedinLeadGenRoute: CrmIntegradoLinkedinLeadGenRoute,CrmIntegradoLojaIntegradaRoute: CrmIntegradoLojaIntegradaRoute,CrmIntegradoMercadoPagoRoute: CrmIntegradoMercadoPagoRoute,CrmIntegradoMobiautoRoute: CrmIntegradoMobiautoRoute,CrmIntegradoMonetizzeRoute: CrmIntegradoMonetizzeRoute,CrmIntegradoOlxRoute: CrmIntegradoOlxRoute,CrmIntegradoOmieRoute: CrmIntegradoOmieRoute,CrmIntegradoPaytRoute: CrmIntegradoPaytRoute,CrmIntegradoPerfectPayRoute: CrmIntegradoPerfectPayRoute,CrmIntegradoPipedriveRoute: CrmIntegradoPipedriveRoute,CrmIntegradoRdStationRoute: CrmIntegradoRdStationRoute,CrmIntegradoRespondiRoute: CrmIntegradoRespondiRoute,CrmIntegradoShopifyRoute: CrmIntegradoShopifyRoute,CrmIntegradoStripeRoute: CrmIntegradoStripeRoute,CrmIntegradoTictoRoute: CrmIntegradoTictoRoute,CrmIntegradoTypeformRoute: CrmIntegradoTypeformRoute,CrmIntegradoVegaCheckoutRoute: CrmIntegradoVegaCheckoutRoute,CrmIntegradoWoocommerceRoute: CrmIntegradoWoocommerceRoute,CrmIntegradoYampiRoute: CrmIntegradoYampiRoute,CrmIntegradoZapVivarealRoute: CrmIntegradoZapVivarealRoute,CrmParaCorretoraDeSegurosRoute: CrmParaCorretoraDeSegurosRoute,EstoqueVeiculosIaWebmotorsRoute: EstoqueVeiculosIaWebmotorsRoute,IntegracoesRoute: IntegracoesRoute,PainelSeoRoute: PainelSeoRoute,PorQuePocESetupRoute: PorQuePocESetupRoute,PrecosRoute: PrecosRoute,PrivacidadeRoute: PrivacidadeRoute,SeoRoute: SeoRoute,SobreRoute: SobreRoute,TermosDeUsoRoute: TermosDeUsoRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)